import { render, staticRenderFns } from "./Expectations.vue?vue&type=template&id=3bc6b49a&"
import script from "./Expectations.vue?vue&type=script&lang=js&"
export * from "./Expectations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports